import React from 'react';
// @ts-ignore
import styles from './ErrorModal.module.css';

interface ErrorModalProps {
    message: string;
    onClose: () => void;
}


const formatMessage = (message: string): string => {
    const words = message.split(' ');
    return words
        .map((word, index) => ((index + 1) % 7 === 0 ? `${word}\n` : word))
        .join(' ');
};

const ErrorModal: React.FC<ErrorModalProps> = ({ message, onClose }) => {
    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <h2>Ошибка</h2>
                <p style={{ whiteSpace: 'pre-line' }}>{formatMessage(message)}</p>
                <div className={styles.buttons}>
                    <button className="createButton" onClick={onClose}>
                        Закрыть
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ErrorModal;
